import * as R from 'ramda'

const AREA_LEVELS = {
  Neighbourhood: 0,
  Sublocality: 1,
  Locality: 2,
}
export const buildChildParentMap = (
  {
    lastSearchObj,
    lcaMapTree,
    lookups,
    prevChildParentMap = {},
  },
) => {
  if(!lookups.classType || !lcaMapTree) return prevChildParentMap
  const _childParentMap = {}
  if(lastSearchObj.neighbourhood_id) {
    lastSearchObj.neighbourhood_id.split(',').forEach(hoodId => {
      const areaId = `Neighbourhood_${hoodId}`
      const parent = lcaMapTree && lcaMapTree[areaId] && lcaMapTree[areaId].parent
      if(_childParentMap[parent]) {
        _childParentMap[parent].push(areaId)
      } else {
        _childParentMap[parent] = [areaId]
      }
    })
  }
  if(lcaMapTree && R.isEmpty(_childParentMap) && lookups.classType === 'Neighbourhood') {
    const lookupArea = `${lookups.classType}_${lookups.id}`
    const parent = lcaMapTree[lookupArea] && lcaMapTree[lookupArea].parent
    if(parent) _childParentMap[parent] = [lookupArea]
  }
  return _childParentMap
}


export const checkDirectAreaLevelExist = (area, childArea) =>
  (AREA_LEVELS[area.areaType] - AREA_LEVELS[childArea.areaType]) === 1

const findMatchedArea = (searchObj, area) => {
  const re = new RegExp(`\\b(${area.areaId})(,\\s*${area.areaId})*\\b`)
  const matched = String(searchObj[area.filterType]).match(re)
  if(matched) return matched[0] === String(area.areaId)
  return false
}
export const isAreaSelectedChecker = (area, lastSearchObj, lookups) => {
  if(!area || !area.filterType) return false
  const isSameArea = area.areaId === lookups.id && area.areaType === lookups.classType
  return lastSearchObj[area.filterType]
    ? isSameArea || findMatchedArea(lastSearchObj, area)
    : isSameArea
}
